import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent,
  DialogTitle, makeStyles, TextField,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  btnWrapper: { position: "relative" },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%", left: "50%",
    marginTop: -12, marginLeft: -12,
  },
  colorRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  colorPreview: {
    width: 36, height: 36,
    borderRadius: "50%",
    border: "1px solid #ccc",
    flexShrink: 0,
  },
}));

const LabelModal = ({ open, onClose, labelId }) => {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [color, setColor] = useState("#7C4DFF");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (labelId) {
      api.get(`/labels`).then(({ data }) => {
        const label = data.find(l => l.id === labelId);
        if (label) { setName(label.name); setColor(label.color); }
      }).catch(toastError);
    } else {
      setName(""); setColor("#7C4DFF");
    }
  }, [open, labelId]);

  const handleClose = () => { onClose(); setName(""); setColor("#7C4DFF"); };

  const handleSave = async () => {
    if (!name.trim()) return;
    setLoading(true);
    try {
      if (labelId) {
        await api.put(`/labels/${labelId}`, { name, color });
        toast.success("Etiqueta atualizada!");
      } else {
        await api.post("/labels", { name, color });
        toast.success("Etiqueta criada!");
      }
      handleClose();
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{labelId ? "Editar Etiqueta" : "Nova Etiqueta"}</DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          label="Nome"
          value={name}
          onChange={e => setName(e.target.value)}
          variant="outlined"
          margin="dense"
          fullWidth
        />
        <div className={classes.colorRow}>
          <span className={classes.colorPreview} style={{ backgroundColor: color }} />
          <TextField
            label="Cor"
            type="color"
            value={color}
            onChange={e => setColor(e.target.value)}
            variant="outlined"
            margin="dense"
            style={{ width: 120 }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" disabled={loading}>Cancelar</Button>
        <div className={classes.btnWrapper}>
          <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>
            Salvar
          </Button>
          {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default LabelModal;
